const accessDashboard = {

    DASHBOARD: { name: 'Dashboard', path: '/dashboard' },

    DASHBOARDSECOND: { name: 'Dashboard', path: '/' },

    INVENTORY_DASHBOARD: { name: 'Inventory Overview', path: '/inventory-dashboard' },

    ASSET_DASHBOARD: { name: 'Asset Overview', path: '/asset-dashboard' },

    MAINTENANCE_DASHBOARD: { name: 'Maintenance Overview', path: '/maintenance-dashboard' },

    AMC_DASHBOARD: { name: 'AMC Overview', path: '/amc-dashboard' },

    PRODUCTION_DASHBOARD: { name: 'Production Overview', path: '/production-dashboard' },

}

export default accessDashboard;